const idiomas = [
  'Português',
  'Libras',
  'Africâner',
  'Aimará',
  'Albanês',
  'Alemão',
  'Árabe',
  'Arménio',
  'Azeri',
  'Bielorrusso',
  'Bengali',
  'Bislama',
  'Bósnio',
  'Búlgaro',
  'Cazaque',
  'Catalão',
  'Checo',
  'Chinês',
  'Coreano',
  'Croata',
  'Curdo',
  'Dinamarquês',
  'Dari',
  'Dhiveli',
  'Dzongkha',
  'Eslovaco',
  'Esloveno',
  'Espanhol',
  'Estoniano',
  'Fijiano',
  'Filipino',
  'Finlandês',
  'Francês',
  'Frísio',
  'Georgiano',
  'Grego',
  'Guarani',
  'Hindi',
  'Holandês',
  'Húngaro',
  'Indonésio',
  'Inglês',
  'Irlandês',
  'Italiano',
  'Japonês',
  'Canará',
  'Khmer',
  'Laociano',
  'Latim',
  'Letão',
  'Lituano',
  'Macedônio',
  'Malaio',
  'Malaiala',
  'Maori',
  'Marata',
  'Moldávio',
  'Mongol',
  'Ndebele',
  'Nepalês',
  'Norueguês',
  'Oriá',
  'Pachto',
  'Persa',
  'Polonês',
  'Punjabi',
  'Quíchua',
  'Quirguiz',
  'Romeno',
  'Romanche',
  'Russo',
  'Sérvio',
  'Cingalês',
  'Somali',
  'Soto',
  'Suaíli',
  'Suázi',
  'Sueco',
  'Tajique',
  'Tâmil',
  'Tétum',
  'Tai',
  'Tsonga',
  'Tswana',
  'Turco',
  'Turcomeno',
  'Ucraniano',
  'Uzbeque',
  'Venda',
  'Vietnamita',
  'Xhosa',
  'Zulu'
]

export default idiomas